import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    curriculums: null
}

const curriculumSlice = createSlice({
    name: "curriculum",
    initialState,
    reducers: {
        init(state, action) {
            state.curriculums = [...action.payload]
            return state;
        },
        add(state, action) {
            state.curriculums = [...state.curriculums, action.payload]
        },
        remove(state, action) {
            state.curriculums = state.curriculums.filter(curriculum => curriculum.id !== action.payload)
        }
    }
})

export const curriculumAction = curriculumSlice.actions;
export default curriculumSlice;